import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import dayjs from '../../../_utils/dayjs.config';

export interface BoardSelectDate{
  name: string, 
  value: string, 
  timePeriodString?: string
}

@Component({
  selector: 'app-board-time-select',
  templateUrl: './board-time-select.component.html',
  styleUrls: ['./board-time-select.component.scss'],
})
export class BoardTimeSelectComponent implements OnInit {

  public customDateStart: string = dayjs().add(-1, "days").toISOString()
  public customDateEnd: string = dayjs().toISOString()

  public selectItems: BoardSelectDate[] = [
    {name: "Alle", value: "all"},
    {name: "Heute", value: "today"},
    {name: "Letzte 7 Tage", value: "7Days"},
    {name: "Letzte 30 Tage", value: "30Days"},
    {name: "Letzte 3 Monate", value: "3Month"},
    {name: "Letzte 6 Monate", value: "6Month"},
    {name: "Letzte 12 Monate", value: "12Month"},
    {name: "Benutzerdefiniert", value: "custom"}
  ] 

  public selectedDate: BoardSelectDate = this.selectItems[0]

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    if(this.selectedDate.value == "custom"){
      const dates: string[] = this.selectedDate.timePeriodString.split("_")
      this.customDateStart = dayjs.utc(dates[0]).toISOString()
      this.customDateEnd = dayjs.utc(dates[1]).toISOString()
    }
  }

  ngOnDestroy(){
    // this.selectedDate = this.selectItems[0]
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async save(){
    
    const selectedData = this.selectItems.find(si => si.value == this.selectedDate.value)
    if(selectedData.value == "custom"){
      selectedData.name = `${ dayjs(this.customDateStart).format("DD.MM.YYYY")} - ${ dayjs(this.customDateEnd).format("DD.MM.YYYY")}`
      selectedData.timePeriodString = `${  dayjs(this.customDateStart).format("yyyy-MM-DD")}_${ dayjs(this.customDateEnd).format("yyyy-MM-DD")}`
    }

    await this.modalCtrl.dismiss(selectedData)
  }

}
